import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../shared/services/notification.sevice';

export function determinePayeeAccountNumber(formValue: any): string {
    if (formValue.payee.accountNumber) {
        return formValue.payee.accountNumber;
    } else if (formValue.payee) {
        return formValue.payee;
    } else {
        throw new Error('A kedvezményezett számlaszáma kötelező.');
    }
}

export function errorHandler(error: any, notificationService: NotificationService) {
    if (error instanceof HttpErrorResponse) {
        if (error.status === 400) {
            const errorMessage = error.error.message || error.message;
            notificationService.showErrorSnackBar(errorMessage);
        } else {
            console.error(error);
            notificationService.showErrorSnackBar('Kiszolgáló hiba.');
        }
    } else {
        console.error(error);
        let message = 'Váratlan hiba.';
        if (error.message === 'A kedvezményezett számlaszáma kötelező.') {
            message = error.message;
        }
        notificationService.showErrorSnackBar(message);
    }
}
